
/* -------------------------------------------------------------------------- */
/*                              PLANS                                  */
/* -------------------------------------------------------------------------- */
export const pitti_plans = [
  {
    id: 151,
    name: "Trial",
    type: "bi-annual",
    provider: "pitti",
    currency: "€",
    seats: 1,
    amount: 0,
    credits: 0,
    crm_included: false,
    max_credits: 10,
    product_id: "",
    price_id: "",
  },
  {
    id: 152,
    name: "Entry level",
    type: "bi-annual",
    provider: "pitti",
    currency: "€",
    seats: 2,
    amount: 350,
    credits: 0,
    crm_included: true,
    max_credits: 40,
    product_id: "",
    price_id: "",
  },
  {
    id: 153,
    name: "Exhibitor full",
    type: "bi-annual",
    provider: "pitti",
    currency: "€",
    seats: 3,
    amount: 1500,
    credits: 0,
    crm_included: true,
    max_credits: 300,
    product_id: "",
    price_id: "",
  },
  {
    id: 154,
    name: "No exhibitor",
    type: "bi-annual",
    provider: "pitti",
    currency: "€",
    seats: 3,
    amount: 1800,
    credits: 0,
    crm_included: true,
    max_credits: 300,
    product_id: "",
    price_id: "",
  },
];
